import {
  Link,
  MessageBar,
  MessageBarBody,
  MessageBarTitle,
} from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ClientRoutes } from "../models/ClientRoutes";

interface OldVersionMessageBarProps {
  type: "activity" | "tool" | "image";
  currentVersion?: { versionId: string; title: string };
  isLoading: boolean;
  isRefetching: boolean;
}

export const OldVersionMessageBar = (props: OldVersionMessageBarProps) => {
  const { type, currentVersion, isLoading, isRefetching } = props;
  const navigate = useNavigate();
  const { t } = useTranslation();

  if (isLoading || isRefetching || !currentVersion) {
    return null;
  }

  const navigateTo =
    type === "activity"
      ? `${ClientRoutes.ActivitiesPublished}/${currentVersion.versionId}`
      : type === "tool"
        ? `${ClientRoutes.ToolsPublished}/${currentVersion.versionId}`
        : `${ClientRoutes.MediaActivityEdit}/overview/${currentVersion.versionId}`;

  return (
    <MessageBar intent="warning">
      <MessageBarBody>
        <MessageBarTitle>{t("oldVersion")}</MessageBarTitle>
        {type === "activity"
          ? t("oldVersionMessageBarTextActivity")
          : type === "tool"
            ? t("oldVersionMessageBarTextTool")
            : t("oldVersionMessageBarTextImage")}
        <Link onClick={() => navigate(navigateTo)}>{currentVersion.title}</Link>
      </MessageBarBody>
    </MessageBar>
  );
};
